import Header from '../../components/Header'
import { Box } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { tokens } from '../../theme'
import { useTheme } from '@mui/material'
import React from "react"
import { useState, useEffect } from "react"

import { ptBR as ptBRGrid } from '@mui/x-data-grid'

import * as Constants from '../../constants'

function arraysEqual(a1, a2) {
  /* WARNING: arrays must not contain {objects} or behavior may be undefined */
  return JSON.stringify(a1) === JSON.stringify(a2)
}

const NotificationClients = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  const [rows, setRows] = useState([])

  const fetchDevices = () => {
    fetch(Constants.HOST + '/notificationClients', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        data = data.data
        let newRows = []
        data.clients.forEach((client) => {
			console.log(client);
          newRows.push({
            id: client.imei,
            owners: client.name ? client.name : 'Nenhum',
          })
        })
        if (!arraysEqual(rows, newRows)) setRows(newRows)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    fetchDevices()
  }, [])

  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    { field: 'owners', headerName: 'Proprietário', flex: 1 },
  ]

  return (
    <Box m="20px"t>
      <Header title="Clientes de notificação" subtitle="Lista de clientes cadastrados via app de livestreams (apenas para consulta)" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-root': { border: 'none', },
          '& .MuiDataGrid-cell': { borderBottom: 'none', },
          '& .name-column--cell': { color: colors.greenAccent[300], },
          '& .MuiDataGrid-columnHeaders': { backgroundColor: colors.blueAccent[700], borderBottom: 'none', },
          '& .MuiDataGrid-virtualScroller': { backgroundColor: colors.primary[400], },
          '& .MuiDataGrid-footerContainer': { borderTop: 'none', backgroundColor: colors.blueAccent[700], },
          '& .MuiCheckbox-root': { color: `${colors.greenAccent[200]} !important`, },
          '& .MuiDataGrid-toolbarContainer .MuiButton-text': { color: `${colors.grey[100]} !important`, },
        }}
      >
        <DataGrid
          checkboxSelection
          rows={rows ? rows : []}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          localeText={ptBRGrid.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick
        />
      </Box>
    </Box>
  )
}

export default NotificationClients
